export * from './src/bookings-services-v2-service-services.schemas.js';
